// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"Gold_fullWidth__QkQSA","label":"Gold_label__SZcDL","root":"Gold_root__9nsLO"};